export var experimentsSpecMap = {
    IS_NEW_BOOKINGS_MEMBERS_AREA_INSTALLED: 'specs.bookings.isNewBookingsMembersAreaInstalled',
};
//# sourceMappingURL=experimentsSpecMap.js.map